<div class="main-wrapper">

    <div class="content" [@routeAnimations]="o.isActivated">
        <router-outlet #o="outlet"></router-outlet>
    </div>

</div>
